var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lw-common-banner',{attrs:{"functionClient":"PC","functionModule":"fusion","userType":"teacher_student","gardenId":_vm.gardenId},scopedSlots:_vm._u([{key:"userInfo",fn:function(){return [_c('lw-user-info')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }